import React, { useRef } from "react";
import { IconButton, Rating, Typography } from "@mui/material";
import { ArrowBack, ArrowForward, FormatQuote } from "@mui/icons-material";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation } from "swiper";
import styles from "./Reviews.module.css";
import { useGetAllReviewsQuery } from "../../Store/Services/reviewService";

const useIsMobile = () => window.innerWidth <= 770;

const Reviews = () => {
  const swiperRef = useRef();
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const isMobile = useIsMobile();

  const { data, error, isLoading } = useGetAllReviewsQuery();

  if (isLoading) return <Typography></Typography>;
  if (error) return <Typography></Typography>;

  const filteredReviews = data.reviews.filter(
    (review) => review.displayInHomePage
  );

  return (
    <div id="reviews" className={styles.container}>
      <Typography variant="h1" className={styles.title}>
        What customers say about Done Right
      </Typography>

      {isMobile ? (
        // ----- Mobile View -----
        <div className={styles.mobileReviewList}>
          {filteredReviews.map((review) => (
            <div key={review.reviewId} className={styles.cardContainerMob}>
              <div className={styles.reviewCard}>
                <Typography className={styles.mobileUsername}>
                  {review.name}
                </Typography>
                <Typography className={styles.description}>
                  {review.review.length > 200
                    ? `${review.review.slice(0, 195)}...`
                    : review.review}
                </Typography>
                <div className={styles.mobileRating}>
                  <Rating
                    value={review.rating}
                    readOnly
                    precision={0.5}
                    sx={{ fontSize: "1.5rem" }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        // ----- Desktop View -----
        <div className={styles.sliderContainer}>
          <IconButton
            ref={prevRef}
            className={`${styles.navButton} ${styles.prevButton}`}
          >
            <ArrowBack />
          </IconButton>

          <Swiper
            ref={swiperRef}
            slidesPerView={3}
            spaceBetween={20}
            slidesPerGroup={1}
            loop={false}
            freeMode={false}
            modules={[Navigation]}
            className={styles.mySwiper}
            onSwiper={(swiper) => {
              setTimeout(() => {
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.params.navigation.nextEl = nextRef.current;
                swiper.navigation.init();
                swiper.navigation.update();
              });
            }}
          >
            {filteredReviews.map((review) => (
              <SwiperSlide key={review.reviewId} className={styles.cardContainer}>
                <div className={styles.reviewCard}>
                  <div className={styles.usernameRating}>
                    <Typography className={styles.username}>
                      {review.name}
                    </Typography>
                  </div>

                  <div
                    className={styles.reviewRating}
                    style={{ position: "relative", padding: "1rem 2rem" }}
                  >
                    <FormatQuote
                      sx={{
                        fontSize: "2rem",
                        color: "#c6ad97",
                        position: "absolute",
                        top: "15px",
                        left: 0,
                        transform: "rotate(180deg)",
                      }}
                    />
                    <Typography
                      className={styles.description}
                      title={review.review}
                    >
                      {review.review.length > 200
                        ? `${review.review.slice(0, 195)}...`
                        : review.review}
                    </Typography>
                    <FormatQuote
                      sx={{
                        fontSize: "2rem",
                        color: "#c6ad97",
                        position: "absolute",
                        bottom: "20px",
                        right: 0,
                      }}
                    />
                  </div>

                  <div className={styles.rating}>
                    <Rating
                      value={review.rating}
                      readOnly
                      precision={0.5}
                      sx={{ fontSize: "2rem" }}
                    />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <IconButton
            ref={nextRef}
            className={`${styles.navButton} ${styles.nextButton}`}
          >
            <ArrowForward />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default Reviews;